
<template>
  <div class="guide_body">
    <div class="guide1">
      <img src="~@/assets/images/space/guide.png" alt=" ">
    </div>
    <div class="guide_text">当前模块灰度发布，暂不支持使用<br>企业/项目资料可以前往
      <span class="guide_button" @click="onClickProject">【项目库】</span>
      <span class="guide_button" @click="onClickShare">【共享资料库】</span>
      使用
    </div>
  </div>
</template>

<script>
export default {
  name: 'Guide',
  created () {
    const path = this.$route.path
    console.log(path)
  },
  methods: {
    onClickProject () {
      this.onClick('gccs_base-paas', 'gccs.zjy-app.zjy_module_project_zsxmk_wcyd')
    },
    onClickShare () {
      this.onClick('gccs_base-paas', 'gccs.zjy-app.zjy_module_gxzlk_ydy')
    },
    onClick (productCode, menuCode) {
      this.$microAppRouter.push({
        productCode: productCode,
        menuCode: menuCode,
        path: '/'
      })
    }
  }
}

</script>

<style scoped lang="less">
.guide_body{
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.guide1{
  width: 180px;
  height: 180px;
  img {
    width: 100%;
    height: 100%;
  }
}
.guide_button {
  color: #4499FF;
  cursor: pointer;
}
.guide_text {
  text-align: center;
  font-size: 12px;
}

</style>
